import React from "react";
import Switch from "react-switch";
import styled from "styled-components";
import { theme } from "@utilities";

interface ISwitchCommon {
    isChecked: boolean;
    setIsChecked: (checked: boolean) => void;
    color?: string;
}

export const SwitchCommon: React.FC<ISwitchCommon> = ({ isChecked, setIsChecked, color }) => {
    return (
        <StyledSwitch
            checked={isChecked}
            onChange={(nextChecked: boolean) => {
                setIsChecked(nextChecked);
            }}
            onHandleColor="#fff"
            onColor={color ?? `${theme.colors.main}`}
            offColor="#E6E6E6"
            handleDiameter={20}
            height={28}
            width={48}
            checkedIcon={
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        color: `${theme.colors.white}`,
                    }}
                >
                    $
                </div>
            }
            uncheckedIcon={
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        color: `${theme.colors.white}`,
                    }}
                >
                    $
                </div>
            }
        />
    );
};

const StyledSwitch = styled(Switch)`
    .react-switch-handle {
        height: 20px !important;
        width: 20px !important;
    }
`;
